import React, {forwardRef, useEffect} from 'react'
import {connect} from "dva";
import {Modal, AutoComplete, Button, Form, Icon, Input, InputNumber, Tooltip} from "antd";
import {modelUtils} from "@/utils";
import {useUpdateEffect} from "ahooks";

const modelNames = [
  'qwen3-235b-a22b-instruct-2507',
]

const Index = (
  {
    refInstance,
    form,

    dispatch,
    changeModal,

    bizId,

    configRes,
    configSaveRes,
    configRemoveRes,
  }
) => {
  const {getFieldDecorator, setFieldsValue, validateFields} = form

  useEffect(() => {
    dispatch({
      type: "llmSetting/getConfiguration",
      payload: {
        key: 'llmSetting@getConfiguration',
        apiParams: {
          bizId,
        },
      },
    })
  }, [])

  useUpdateEffect(() => {
    const {success, msg, data} = configRes || {}

    if (!success) {
      wizNotice.error(msg);
      return;
    }

    setFieldsValue({
      ...data,
    })
  }, [configRes])

  useUpdateEffect(() => {
    const {success, msg, data} = configSaveRes || {}
    if (!success) {
      wizNotice.error(msg);
      return;
    }
    wizNotice.success(msg)
    changeModal && changeModal(false);
  }, [configSaveRes])

  useUpdateEffect(() => {
    const {success, msg, data} = configRemoveRes || {}
    if (!success) {
      wizNotice.error(msg);
      return;
    }
    wizNotice.success(msg)
    changeModal && changeModal(false);
  }, [configRemoveRes])


  const _submit = () => {
    validateFields()
      .then(value => {
        dispatch({
          type: "llmSetting/setConfiguration",
          payload: {
            key: "llmSetting@save",
            apiParams: {
              ...value,
              bizId,
            },
          },
        });
      })
      .catch(err => {
        console.log('_submit', 'err', err)
      })
  }

  const _remove = () => {
    Modal.confirm({
      title: '确定删除吗？',
      content: '删除后无法恢复',
      onOk() {
        dispatch({
          type: "llmSetting/removeConfiguration",
          payload: {
            key: "llmSetting@remove",
            apiParams: {
              id: configRes?.data?.id,
            },
          },
        });
      },
    });
  }

  return (
    <Form>
      <Form.Item label={'模型名称'}>
        {
          getFieldDecorator('modelName', {
            rules: [
              {required: true, message: '请输入模型名称'},
            ],
          })(<AutoComplete placeholder={'请输入模型名称'} dataSource={modelNames}/>)
        }
      </Form.Item>
      <Form.Item
        label={
          <span>
            提示词&nbsp;
            <Tooltip
              title={
                <div>
                  支持的变量:
                  <ul>
                    <li>题目：#questionResult#</li>
                    <li>范文答案：#modelAnswer#</li>
                    <li>背景说明：#backgroundNote#</li>
                    <li>所有规则内容：#correctAnswerAll#</li>
                    <li>当前批阅的规则：#correctAnswer#</li>
                    <li>当前批阅规则提示词：#correctAnswerPromptWord#</li>
                    <li>学员答案：#sys.query#</li>
                  </ul>
                </div>
              }
            >
              <Icon type={'question-circle-o'}/>
            </Tooltip>
          </span>
        }
      >
        {
          getFieldDecorator('promptWord', {
            rules: [
              {required: true, message: '请输入提示词'},
            ],
          })(<Input.TextArea autosize={{minRows: 8, maxRows: 25}} placeholder={'请输入提示词'}/>)
        }
      </Form.Item>
      <Form.Item label={'模型温度'}>
        {
          getFieldDecorator('temperature', {
            rules: [
              // {required: true, message: '请输入模型温度'},
            ],
          })(<InputNumber style={{width: '100%'}} placeholder={'请输入模型温度'} step={0.1} min={0} max={2}/>)
        }
      </Form.Item>
      <Form.Item label={'请求返回的最大 Token 数'}>
        {
          getFieldDecorator('maxTokens', {
            rules: [],
          })(
            <InputNumber
              style={{width: '100%'}}
              placeholder={'请输入请求返回的最大 Token 数'}
              step={1}
              min={0}
              precision={0}/>
          )
        }
      </Form.Item>
      <Form.Item wrapperCol={{span: 24}}>
        <div style={{width: "100%", display: "flex", gap: 10, justifyContent: "right"}}>
          <Button hidden={bizId === 0 || !configRes?.data?.id} type={'danger'} onClick={() => _remove()}>删除</Button>
          <Button type={'primary'} onClick={() => _submit()}>提交</Button>
          <Button onClick={() => changeModal(false)}>取消</Button>
        </div>
      </Form.Item>
    </Form>
  )
}

const mapStateToProps = (state, ownProps) => {
  const {llmSetting} = state

  const configRes = modelUtils.getModelEntity(llmSetting, "llmSetting@getConfiguration");
  const configSaveRes = modelUtils.getModelEntity(llmSetting, "llmSetting@save");
  const configRemoveRes = modelUtils.getModelEntity(llmSetting, "llmSetting@remove");

  //获取loading的方式
  const load = modelUtils.getLoadingState(state, ['llmSetting'])

  return {
    configRes,
    configSaveRes,
    configRemoveRes,
    ...load,
  }
};

const Tc = connect(mapStateToProps, null, null, {forwardRef: true})(Index)
// export default forwardRef((props, ref) => <Tc {...props} refInstance={ref}/>)
export default Form.create()(forwardRef((props, ref) => <Tc {...props} refInstance={ref}/>))
